import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/shared/api';

export function useDynamicPricingCalendarDetail(
  propertyGroupId: string | undefined,
  propertyId: string | undefined,
  date: string | undefined,
) {
  const api = useApi();
  return useQuery({
    queryKey: ['dynamic-pricing-calendar-detail', propertyGroupId, propertyId, date],
    queryFn: () => api.dynamicPricingCalendar.getDetail(propertyGroupId!, propertyId!, date!),
    enabled: !!propertyGroupId && !!propertyId && !!date,
  });
}
